<div class="box-upload" (click)="upload.click()">
  <input type="file" class="d-none" #upload (change)="uploadFile($event)" />
  <img *ngIf="modelImage && modelImage?.type != 'pdf'" class="d-none" #image [src]="modelImage?.base64" alt=""
    (load)="checkImage(image)" />
  <div class="box-image">
    <ng-content></ng-content>
    <div class="upload-image pointer text-center" *ngIf="action">
      <span class="btn-upload icon-start sm mt-1">
        <span class="material-symbols-outlined">
          edit
        </span>
        อัพโหลดรูปภาพ
      </span>
      <p>อัพโหลดรูปภาพ ขนาดไฟล์ไม่เกิน 1 MB</p>
    </div>
  </div>
</div>